import * as React from 'react';
import {useEffect} from 'react';
import { GetUrl, CTicksToDateString } from '../Utility.js';
import { useSelector,useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';


function BettingBox()
{
    const state=useSelector((state)=>state);
    const dispatch = useDispatch();

    const navigate = useNavigate();

    const ArrayClick = async (resultArray) =>
        {
            try
            {
                if(state.Request === 1)
                {
                    return;
                }
    
                var secretkey = sessionStorage.getItem("secret_key");
                if(secretkey === null)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                    return;    
                }
                
                dispatch({type:'Request'});

                const data = {
                    secret_key: secretkey,
                    result_array: resultArray // 결과 값 배열
                  };

                const response = await fetch(GetUrl() + 'RecordArray/RecordArray', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(data),
                });
    
                if (response.ok) {
                    const data = await response.json();
                    
                    if(data.result === 0)
                    {
                        dispatch({type:'UpdateRemainTime', RemainTime:data.remain_time});
            
                        for (let i = 0; i < resultArray.length; i++) {
                            
                            dispatch({type:'UpdateResult',result:resultArray[i]});
                        }

                        dispatch({type:'UpdateRecord',record:data.record_array,stage_count:data.stage_count});
                    }
                    else if(data.result === 3)
                    {
                        alert('유저 정보 만료(다시 로그인 해주세요)');  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 21) // 점검 중
                    {
                        var startTime = CTicksToDateString(data.start_time);
                        var endTime = CTicksToDateString(data.end_time);
        
                        var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                        alert(message);  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 12)
                    {
                        alert('사용 시간을 모두 소진 했습니다. 시간권 사용 후 다시 이용해 주세요.');  
                    }
    
                } else {
                    alert('Network Fail');
                }
    
                dispatch({type:'Response'});
            }
            catch(error)
            {
                dispatch({type:'Response'});
                console.error(error);
            }
        };

        useEffect(() => {
            window.ArrayClick = ArrayClick;

            return () => {
                // 컴포넌트 언마운트 시 정리
                delete window.ArrayClick;
            };
        }, []);

    
    const PlayerClick = async (e) => 
    {
        e.preventDefault();
        try
        {
            if(state.Request === 1)
            {
                return;
            }

            var secretkey = sessionStorage.getItem("secret_key");
            if(secretkey === null)
            {
              alert('유저 정보 만료(다시 로그인 해주세요)');  
              navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
              return;    
            }
            
            dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'Record/Record', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ secret_key : secretkey, result : "P" }),
            });

            if (response.ok) {
                const data = await response.json();
                if(data.result === 0)
                {
                    dispatch({type:'UpdateRemainTime', RemainTime:data.remain_time});
                    dispatch({type:'UpdateResult',result:"P"});
                    dispatch({type:'UpdateRecord',record:data.record_array,stage_count:data.stage_count});
                }
                else if(data.result === 3)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 21) // 점검 중
                {
                  var startTime = CTicksToDateString(data.start_time);
                  var endTime = CTicksToDateString(data.end_time);
    
                  var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                  alert(message);  
                  navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 12)
                {
                    alert('사용 시간을 모두 소진 했습니다. 시간권 사용 후 다시 이용해 주세요.');  
                }
            } 
            else
            {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
        }
        catch(error)
        {
            dispatch({type:'Response'});
            console.error(error);
        }
    };

    const BankerClick = async (e) =>
    {
        e.preventDefault();
        try
        {
            if(state.Request === 1)
            {
                return;
            }

            var secretkey = sessionStorage.getItem("secret_key");
            if(secretkey === null)
            {
              alert('유저 정보 만료(다시 로그인 해주세요)');  
              navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
              return;    
            }
            
            dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'Record/Record', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ secret_key : secretkey, result : "B" }),
            });

            if (response.ok) {
                const data = await response.json();
                
                if(data.result === 0)
                {
                    dispatch({type:'UpdateRemainTime', RemainTime:data.remain_time});
                    dispatch({type:'UpdateResult',result:"B"});
                    dispatch({type:'UpdateRecord',record:data.record_array,stage_count:data.stage_count});
                }
                else if(data.result === 3)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 21) // 점검 중
                {
                  var startTime = CTicksToDateString(data.start_time);
                  var endTime = CTicksToDateString(data.end_time);
    
                  var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                  alert(message);  
                  navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 12)
                {
                    alert('사용 시간을 모두 소진 했습니다. 시간권 사용 후 다시 이용해 주세요.');  
                }

            } else {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
        }
        catch(error)
        {
            dispatch({type:'Response'});
            console.error(error);
        }
    };

    const TieClick = async (e) =>
        {
            e.preventDefault();
            try
            {
                if(state.Request === 1)
                {
                    return;
                }
    
                var secretkey = sessionStorage.getItem("secret_key");
                if(secretkey === null)
                {
                  alert('유저 정보 만료(다시 로그인 해주세요)');  
                  navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                  return;    
                }
                
                dispatch({type:'Request'});
                const response = await fetch(GetUrl() + 'Record/Record', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ secret_key : secretkey, result : "T" }),
                });
    
                if (response.ok) {
                    const data = await response.json();
                    
                    if(data.result === 0)
                    {
                        dispatch({type:'UpdateRemainTime', RemainTime:data.remain_time});
                        dispatch({type:'UpdateResult',result:"T"});
                        dispatch({type:'UpdateRecord',record:data.record_array,stage_count:data.stage_count});
                    }
                    else if(data.result === 3)
                    {
                        alert('유저 정보 만료(다시 로그인 해주세요)');  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 21) // 점검 중
                    {
                      var startTime = CTicksToDateString(data.start_time);
                      var endTime = CTicksToDateString(data.end_time);
        
                      var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                      alert(message);  
                      navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 12)
                    {
                        alert('사용 시간을 모두 소진 했습니다. 시간권 사용 후 다시 이용해 주세요.');  
                    }
    
                } else {
                    alert('Network Fail');
                }
    
                dispatch({type:'Response'});
            }
            catch(error)
            {
                dispatch({type:'Response'});
                console.error(error);
            }
        };



    return (        
    <div className='betting-box'>
            <div className='betting-player-box' onClick={PlayerClick}>
                <h2><p>PLAYER</p></h2>
            </div>
            <div className='betting-tie-box' onClick={TieClick}>
                <h2><p>TIE</p></h2>
            </div>
            <div className='betting-banker-box' onClick={BankerClick}>
                <h2><p>BANKER</p></h2>
            </div>
    </div>
    );
}

export default BettingBox